let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4GRhR")).then(() => parcelRequire('4ynVq'));